var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPinSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    viewBox: "0 0 45.524 60",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-83.523 -17.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.978 76.136a3.492 3.492 0 004.615 0c.835-.736 20.455-18.223 20.455-36.359a22.762 22.762 0 10-45.524 0c-.002 18.136 19.618 35.623 20.454 36.359zm2.307-42.308a5.95 5.95 0 11-5.9 5.95 5.925 5.925 0 015.9-5.95z",
    fill: "#ee1848"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.523,
    cy: 39.007,
    fill: "#fff",
    r: 8
  }))));
}

export default SvgPinSelected;